'use strict';

// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').controller('DepositoEditCtrl', function($location, $scope, $routeParams, $rootScope, $q,
  DepositosService, Flash, GlebasService, LoadingService, MessagesService, PropriedadesService) {
  $scope.glebasPropriedade = [];

  const listPropriedades = function() {
    const deferred = $q.defer();
    PropriedadesService.all(null, $scope.deposito.cd_deposito).then(function(propriedades) {
      $scope.allPropriedades = propriedades.data.filter(function(propriedade) {
        return !(($scope.deposito.propriedades || []).filter(function(propriedadeDeposito) {
          return propriedadeDeposito.id === propriedade.id;
        }).length);
      });
      deferred.resolve();
    }, deferred.reject);
    return deferred.promise;
  };

  const initialize = function() {
    $rootScope.initialize.then(function() {
      if (!$rootScope.permissions.funcao.canManage) {
        $location.path('/');
        Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
        return;
      }

      LoadingService.showLoading();

      DepositosService.get($routeParams.id).then(function(deposito) {
        $scope.deposito = deposito.data;
        $scope.deposito.loading = false;

        return listGlebas(($scope.deposito.propriedades || [])[0]).then(listPropriedades);
      }, function() {
        MessagesService.error('Erro', 'Erro ao recuperar dados, tente novamente.');
      })
        .finally(LoadingService.hideLoading);
    }, $rootScope.errorRootInitialize);
  };

  initialize();

  $scope.changeGlebasPropriedade = function() {
    $scope.deposito.glebas = [];
    $scope.deposito.loading = true;
    if (($scope.deposito.propriedades || []).length === 1) {
      listGlebas($scope.deposito.propriedades[0]).then(function() {
        $scope.deposito.loading = false;
      });
    } else {
      $scope.deposito.loading = false;
    }
  };

  function listGlebas(propriedade) {
    const deferred = $q.defer();
    if (propriedade) {
      GlebasService.list({ propriedade: propriedade.id }).then(function(glebas) {
        $scope.glebasPropriedade = glebas.data;
        listPropriedades().then(deferred.resolve, deferred.reject);
      }, deferred.reject);
    } else {
      deferred.resolve();
    }
    return deferred.promise;
  }

  $scope.addGleba = function($select) {
    $scope.glebas.forEach(function(gleba) {
      if (gleba.id === $select.id) {
        gleba.selected = true;
      }
    });
    $scope.gleba.selected = null;
  };


  $scope.goToShow = function() {
    $location.path(`/depositos/${ $scope.deposito.cd_deposito}`);
  };

  $scope.clearGlebas = function() {
    if ($scope.deposito.em_uso) {
      $scope.deposito.glebas = [];
    }
  };

  $scope.save = function(form) {
    if (form.$invalid) {
      return;
    }

    LoadingService.showLoading();
    DepositosService.save($scope.deposito).then(function() {
      $scope.goToShow();
      Flash.create(REGISTRO_SALVO_COM_SUCESSO.type, REGISTRO_SALVO_COM_SUCESSO.msg);
    }, function(error) {
      let mensagem = 'Falha ao salvar o registro: <br>';
      try {
        Object.keys(error.data).forEach(function(key) {
          mensagem += error.data[key][0];
        });
      } catch (err) {
        mensagem = FALHA_AO_SALVAR_REGISTRO.msg;
      }
      Flash.create(FALHA_AO_SALVAR_REGISTRO.type, mensagem);
    })
      .finally(LoadingService.hideLoading);
  };
});
